export default __webpack_public_path__ + "static/media/FB_Logo_Reversed_RGB_Icon.895fbf61.png";